import "./mining.css";
import React from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import imge1 from "../../assets/image4.png";

import imge3 from "../../assets/ETHDollarMinin.png";

const Mining2 = () => {
    const [stake, setStake] = React.useState("Staking");

    return (  
        <div className="col-md-12 col-lg-10" id="sizing">
        <div className="miningRow1">
          <div className="aknsaknnn"  onClick={() => {
            var x = document.querySelector(".wrapper2");
            if (x.style.display === "block") {
              x.style.display = "none";
            } else {
              x.style.display = "block";
            }
          }}>
            <div className="miningImgeDiv">
              <img
                className="miningImg pr-5"
                src={imge1}
                alt="no preview"
              />
              <img
                className="miningImg"
                src={imge3}
                alt="no preview"
              />
            </div>
            <div className="miningFMTAdiv">
              <p className="miningFMTApara">FMTA/USDC</p>
            </div>
            <div>
              <p className="miningPara4">$4998</p>
            </div>
            <div>
              <p className="miningPara3">50.45%</p>
              <p className="miningPara5">annulize</p>
            </div>
          </div>
          <div className="wrapper2" style={{ display: "none" }}>
          <div className="two_item">
            <div className="jbscbhch">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckDefault2"
                  onClick={() => {
                    var onOff = document.querySelector(
                      "#flexSwitchCheckDefault2"
                    );
                    var stake = document.querySelector("#stakeIt");
                    var unstake = document.querySelector("#unstake2");
                    if (onOff.checked) {
                      onOff.style.backgroundColor = "red";

                      setStake("Unstaking");
                      unstake.style.display = "block";
                      stake.style.display = "none";
                    } else {
                      onOff.style.backgroundColor = "green";
                      setStake("Staking");
                      unstake.style.display = "none";
                      stake.style.display = "block";
                    }
                  }}
                />
              </div>
              <span>{stake}</span>
            </div>

            <div>
              <button className="reward_btn">
                Harvest Rewards
              </button>
            </div>
          </div>

          {/*Stack Mining*/}
          <div className="main" id="stakeIt">
            <div className="row">
              <div className="col-xl-8 col-lg-8 col-md-8 col-12 m-auto">
                <div className="three_btn">
                  <button>5 Days</button>
                  <button>10 Days</button>
                  <button>15 Days</button>
                </div>

                <div className="field m-auto">
                  <input
                    className="homeParag1"
                    type="text"
                    placeholder="0.00"
                  />
                  <div className="homeSpanDiv">
                    <button className="homeSpan3"> MAX</button>
                  </div>
                </div>

                <div className="stackCompounding">
                  <div>
                    <p>FMTA/ETH LP in Wallet:</p>
                  </div>
                  <div>
                    <p>0.00</p>
                  </div>
                </div>
                <div className="stackCompounding">
                  <div>
                    <p>Rewards Earned:</p>
                  </div>
                  <div>
                    <p>0.00</p>
                  </div>
                </div>
                <div className="two_btn">
                  <div className="reward_btn">
                    <button className="addPos">+ Add to position</button>
                  </div>
                  <div className="reward_btn">
                    <button>Stake</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*Stake Ends here*/}
          <div
            className="main"
            id="unstake2"
            style={{ display: "none" }}
          >
            <div className="row">
              <div className="col-xl-8 col-lg-8 col-md-8 col-12 m-auto">
                {/* <div className="three_btn">
            <button>5 Days</button>
            <button>10 Days</button>
            <button>15 Days</button>
          </div> */}

                <div className="field m-auto">
                  <input
                    className="homeParag1"
                    type="text"
                    placeholder="0.00"
                  />
                  <div className="homeSpanDiv">
                    <button className="homeSpan3"> MAX</button>
                  </div>
                </div>

                <div className="stackCompounding">
                  <div>
                    <p>FMTA/ETH LP in Wallet:</p>
                  </div>
                  <div>
                    <p>0.00</p>
                  </div>
                </div>
                <div className="stackCompounding">
                  <div>
                    <p>Rewards Earned:</p>
                  </div>
                  <div>
                    <p>0.00</p>
                  </div>
                </div>
                <div className="two_btn">
                  {/* <div className="reward_btn">
              <button>+ Add to position</button>
            </div> */}
                  <div className="reward_btn">
                    <button id="remove_pos">
                      Remove Position
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    );
}
 
export default Mining2;